import styled, { css } from 'styled-components';

import { ReactComponent as MarkedCompletedIcon } from '../../../../assets/icons/marked-complete.svg';
import { ReactComponent as MarkedIncompleteIcon } from '../../../../assets/icons/marked-incomplete.svg';
import colors from '../../../../styles/colors';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  &:nth-of-type(odd) {
    background-color: ${colors.base.alpha};
  }
  &:nth-of-type(even) {
    background-color: ${colors.addAlpha(colors.shades.gamma5, 0.3)};
  }
`;

// Fixed columns so days line up: day | workouts | health.
const ContentRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  align-items: start;
  position: relative;
  cursor: ${({ $hasProgression }) => ($hasProgression ? 'pointer' : 'default')};
`;

const StyledTitle = styled.span`
  font-size: 12px;
  font-weight: 600;
  line-height: 22px;
  color: ${({ $hasWorkouts }) => ($hasWorkouts ? colors.base.beta : colors.shades.gamma8)};
`;

const Summary = styled.span`
  font-size: 10px;
  font-weight: 400;
  line-height: 16px;
  white-space: pre-wrap;
`;

const WorkoutItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const WorkoutStatusContainer = styled.div`
  display: flex;
  margin-right: 10px;
`;

const WorkoutName = styled.div`
  font-size: 10px;
  font-weight: 400;
  line-height: 16px;
`;

const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 6px 12px;
  margin: 10px 8px;
  align-items: left;
  min-width: 0;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

const ExpandLabel = styled.span`
  font-size: 10px;
  font-weight: 400;
  color: ${colors.base.beta};
  white-space: nowrap;
  position: absolute;
  top: 10px;
  right: 12px;
  &::after {
    content: '${({ $isExpanded }) => ($isExpanded ? ' ▲' : ' ▼')}';
  }
`;

const ProgressionSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 12px 12px;
  border-top: 1px solid ${colors.addAlpha(colors.shades.gamma5, 0.5)};
`;

const WorkoutTitle = styled.span`
  font-size: 11px;
  font-weight: 600;
  line-height: 20px;
  color: ${colors.base.beta};
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
`;

const WorkoutTitleDot = styled.span`
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${colors.shades.gamma8};
  flex-shrink: 0;
`;

const ExerciseProgressionRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
  gap: 8px;
`;

const ExerciseName = styled.span`
  font-size: 10px;
  font-weight: 400;
  line-height: 16px;
  color: ${colors.base.beta};
  flex: 1;
`;

const ExerciseDivider = styled.div`
  height: 1px;
  background-color: ${colors.addAlpha(colors.shades.gamma5, 0.5)};
`;

const iconStyle = css`
  height: 12px;
  width: 12px;
`;

const CompletedIcon = styled(MarkedCompletedIcon)`
  ${iconStyle};
`;

const IncompleteIcon = styled(MarkedIncompleteIcon)`
  ${iconStyle};
`;

const BadgeGroup = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
`;

export {
  Container,
  ContentRow,
  BadgeGroup,
  WorkoutTitleDot,
  ItemContainer,
  Column,
  StyledTitle,
  WorkoutItem,
  WorkoutStatusContainer,
  WorkoutName,
  CompletedIcon,
  IncompleteIcon,
  Summary,
  ExpandLabel,
  ProgressionSection,
  WorkoutTitle,
  ExerciseProgressionRow,
  ExerciseName,
  ExerciseDivider,
};
